import { IAuthenticateResponseGameConfig, IPayTableSymbol } from '@GFTypes/Responses/AuthenticateResponse';

export const processPayTableSymbols = (gameConfig: IAuthenticateResponseGameConfig): IPayTableSymbol[][] => {
    return gameConfig.symbols.map((symbols) =>
        symbols.map((symbol) => ({ ...symbol, roles: (symbol.roles ?? []).map((role) => ({ ...role, types: role.types ?? role.type ?? [] })) }))
    );
};
